// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1StateSchema = z.object({
  id: z.number().int(),
  name: z.coerce.string(),
  icon: z.coerce.string().nullish(),
  color: z.coerce.string(),
  billed: z.boolean(),
  locked: z.boolean(),
  system_managed: z.boolean(),
  custom: z.boolean(),
  deleted: z.boolean(),
  updated_at: z.number().int(),
  created_at: z.number().int(),
  permissions: z.array(z.object({
    id: z.number().int(),
    role_id: z.number().int(),
    state_id: z.number().int(),
    team_lead: z.boolean(),
    project_lead: z.boolean(),
    operation: z.coerce.string(),
    updated_at: z.number().int(),
    created_at: z.number().int(),
  })),
});
